import React from "react";
import { Link } from "react-router-dom";
import { History } from "history";
import { FormattedMessage } from "react-intl";

import { ExitToApp, ArrowForward } from "components/Icons";
import { URLS } from "constants/urlConstants";
import SideMenu from "./SideMenu";
import Header from "./Header";
import Footer from "./Footer";

import "./PageLayout.scss";

interface IProps {
  isLoading: boolean;
  history: History;
}

interface IState {
  isHomeMenuVisible: boolean;
}

class PageLayout extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      isHomeMenuVisible: false
    };
  }

  private toggleHomeMenu = () => {
    this.setState(({ isHomeMenuVisible }) => ({
      isHomeMenuVisible: !isHomeMenuVisible
    }));
  };

  public render() {
    const { children, isLoading } = this.props;
    const { isHomeMenuVisible } = this.state;

    return (
      <div
        id="page-container"
        className={isHomeMenuVisible ? "home-menu-visible" : ""}
      >
        {isLoading && <div className="fixed-loading" />}

        <div className="home-modal">
          <FormattedMessage id="CNB_DESCRIPTION" tagName="h1" />
          <div className="menu-row" onClick={this.toggleHomeMenu}>
            <div>
              <Link to={URLS.SERVICE_AND_SUPPORT_URL}>
                <ArrowForward className="menu-icons" />{" "}
                <FormattedMessage id="FAQ" />
              </Link>
              <Link to={URLS.SERVICE_AND_SUPPORT_URL}>
                <ArrowForward className="menu-icons" />{" "}
                <FormattedMessage id="SUPPORT" />
              </Link>
            </div>
            <div>
              <Link to={URLS.HOME_URL}>
                <ExitToApp className="menu-icons" />{" "}
                <FormattedMessage id="WEBSITE" />
              </Link>
              <Link to={URLS.CONTACT_URL}>
                <ExitToApp className="menu-icons" />{" "}
                <FormattedMessage id="CONTACT" />
              </Link>
            </div>
          </div>
        </div>
        <div className="page">
          <div
            className="home-modal-page-blur"
            onClick={() => this.toggleHomeMenu()}
          >
            &nbsp;
          </div>
          <SideMenu />
          <div className="right-page">
            <Header onHomeClicked={() => this.toggleHomeMenu()} />
            <div className="page-content">{children}</div>
            <Footer />
          </div>
        </div>
      </div>
    );
  }
}

export default PageLayout;
